// utils/beds.js — จัดรูปแบบข้อมูลเตียงของห้องพัก (room.beds) ให้เป็นข้อความตามภาษา
// ใช้ร่วมกัน 3 ที่: RoomDetail, BookingDetailPage และ preview ในหน้า AdminRooms
// (แอดมินจะได้เห็นข้อความเดียวกับที่แขกเห็นเป๊ะๆ)
import { t } from "../i18n";

/** กรองแถวเตียงที่ไม่สมบูรณ์ทิ้ง + แปลงเป็นตัวเลข (ข้อมูลอาจมาจาก doc เก่าที่ยังไม่มี beds) */
export function normalizeBeds(beds) {
  if (!Array.isArray(beds)) return [];
  return beds
    .map(b => ({ size: Number(b?.size), count: Number(b?.count) }))
    .filter(b => Number.isFinite(b.size) && b.size > 0 && Number.isFinite(b.count) && b.count > 0);
}

/** จำนวนเตียงรวมทุกขนาด (เช่น ห้องเตียงใหญ่ 1 เล็ก 1 = 2) */
export function totalBeds(beds) {
  return normalizeBeds(beds).reduce((sum, b) => sum + b.count, 0);
}

/* 3.5 → "3.5", 5 → "5" (ไม่เอา "5.0") */
const fmtSize = (n) => String(Number(n));

/**
 * แปลงเป็นข้อความพร้อมแสดง เช่น "5 ฟุต × 1 เตียง + 3.5 ฟุต × 1 เตียง"
 * คืน "" เมื่อไม่มีข้อมูลเตียง — ผู้เรียกใช้ค่านี้ตัดสินใจว่าจะซ่อนบรรทัดนั้นไปเลย
 */
export function formatBeds(lang, beds) {
  const list = normalizeBeds(beds);
  if (!list.length) return "";
  return list.map(b => t(lang, "bedSpec", fmtSize(b.size), b.count)).join(" + ");
}
